module.exports = __webpack_public_path__ + "static/img/img_4.dad19abe.jpg";